import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PartnerHeader from './partner.header.component';
import MobileFooter from './web/mobile.footer.component';
import Component01 from './web/component_01';
import Component02 from './web/component_02';
import Component03 from './web/component_03';
import Component05 from './web/component_05';
import Component04 from './web/component_04';
import Component06 from './web/component_06';
import Component07 from './web/component_07';
import Component08 from './web/component_08';
import Component09 from './web/component_09';
import WebFooter from './web/footer';

const PartnerComponent = ({...props}) : React.ReactElement => {
    const isMobile = useMediaQuery('(min-width:320px) and (max-width:767px)', { noSsr: true });        
    const styles = getStyles();

    return (
        <>
            <div style={styles.webScreen}>
                <PartnerHeader />
                    {isMobile && (<MobileFooter />)}
                <div style={{ height: "50px" }} />
                <Component01 />
                <Component02 />
                <Component03 />
                <Component04 />
                <Component05 />
                <Component06 />
                <Component07 />
                <Component08 />
                <Component09 />
                <WebFooter />
            </div>
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    webScreen: { width: "100%", minWidth: "320px", WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none', userSelect: 'none'},
});

export default PartnerComponent;